import { Injectable } from '@angular/core';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as clusterLabelCreator from "@arcgis/core/smartMapping/labels/clusters.js";
import MapView from '@arcgis/core/views/MapView';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import Polyline from '@arcgis/core/geometry/Polyline';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";

@Injectable({
  providedIn: 'root'
})
export class MapService {
  constructor() { }

  async generatePoints(pinArray: any[], currentNews: any): Promise<{ id: number, longitude: number, latitude: number , Topic_OD: string, Detail_OD: string, Link_OD: string,Picture_URL_OD: string, isMainNews: string}[]> {
    const points: { id: number, longitude: number, latitude: number , Topic_OD: string, Detail_OD: string, Link_OD: string, Picture_URL_OD: string, isMainNews: string}[] = [];
    let idCounter: number = 0;
    for (let i = 0; i < pinArray.length; i++) {

        let lat: number, lon: number;
        const latLonList = pinArray[i].LAT_LON_List;
        
        if (latLonList && Array.isArray(latLonList)) {
            
            for (let j = 0; j < latLonList.length; j++) {
              const latLon = latLonList[j].split(',');
              
              lat = parseFloat(latLon[0].trim());
              lon = parseFloat(latLon[1].trim());

              const isMainNews = currentNews.Topic_OD === pinArray[i].Topic_OD ? 'true' : 'false'; 

              points.push({ 
                  id: ++idCounter,
                  longitude: lon, 
                  latitude: lat, 
                  Topic_OD: pinArray[i].Topic_OD,
                  Detail_OD: pinArray[i].Detail_OD,
                  Link_OD: encodeURIComponent(pinArray[i].Link_OD),
                  Picture_URL_OD: pinArray[i].Picture_URL_OD,
                  isMainNews: isMainNews
              });
            }
            
        } else {
            continue
        }
    }
    return points;
  }

  async generatePointsWithOutMainNews(pinArray: any[]): Promise<{ id: number, longitude: number, latitude: number , Topic_OD: string, Detail_OD: string, Link_OD: string , Picture_URL_OD: string}[]> {
    const points: { id: number, longitude: number, latitude: number , Topic_OD: string, Detail_OD: string, Link_OD: string , Picture_URL_OD: string}[] = [];
    let idCounter: number = 0;
    for (let i = 0; i < pinArray.length; i++) {

        let lat: number, lon: number;
       
        const latLonList = pinArray[i].LAT_LON_List;
        
        if (latLonList && Array.isArray(latLonList)) {
            
            for (let j = 0; j < latLonList.length; j++) {
              const latLon = latLonList[j].split(',');
              
              lat = parseFloat(latLon[0].trim());
              lon = parseFloat(latLon[1].trim());
              
              points.push({ 
                  id: ++idCounter,
                  longitude: lon, 
                  latitude: lat, 
                  Topic_OD: pinArray[i].Topic_OD,
                  Detail_OD: pinArray[i].Detail_OD,
                  Link_OD: encodeURIComponent(pinArray[i].Link_OD),
                  Picture_URL_OD: pinArray[i].Picture_URL_OD
              });
            }
            
        } else {
            continue
        }
    }
    return points;
  }

  async generateCondoPoints(condoList: any[]): 
  Promise<{ 
    id: number, 
    longitude?: number, 
    latitude?: number , 
    Project: string, 
    Location: string, 
    Description: string ,
    RoomSize: string, 
    Bedroom: number, 
    Bathroom: number, 
    Cost: number 
  }[]> {
    const points: { 
      id: number, 
      longitude?: number, 
      latitude?: number , 
      Project: string, 
      Location: string, 
      Description: string ,
      RoomSize: string, 
      Bedroom: number, 
      Bathroom: number, 
      Cost: number }[] = [];

    let idCounter: number = 0;
    for (let i = 0; i < condoList.length; i++) {

        
        if (condoList[i].Latitude == null){
          continue;
        }
        let lat: number, lon: number;
        lat = condoList[i].Latitude
        lon = condoList[i].Longitude
        
        points.push({ 
          id: ++idCounter,
          longitude: lon, 
          latitude: lat, 
          Project: condoList[i].Project,
          Location: condoList[i].Location,
          Description: condoList[i].Description,
          RoomSize: condoList[i].RoomSize,
          Bedroom: condoList[i].Bedroom,
          Bathroom: condoList[i].Bathroom,
          Cost: condoList[i].Cost
        });

    }
    return points;
  }

  createGraphicsFromPointsCondo(condoPoints: { 
    id: number, 
    longitude?: number, 
    latitude?: number , 
    Project: string, 
    Location: string, 
    Description: string ,
    RoomSize: string, 
    Bedroom: number, 
    Bathroom: number, 
    Cost: number 
}[]): Graphic[] {
    const graphics: Graphic[] = [];
    const mainMarker = new PictureMarkerSymbol({
      url: 'assets/map-page-component-images/mainPin.svg',
      width: '32px',
      height: '40px'
    });
    for (const data of condoPoints) {
        const point = new Point({
            longitude: data.longitude,
            latitude: data.latitude
        });

        const graphic = new Graphic({
            geometry: point,
            symbol: mainMarker,
            attributes: {
                Project: data.Project,
                Location: data.Location,
                RoomSize: data.RoomSize,
                Bedroom: data.Bedroom,
                Bathroom: data.Bathroom,
                Cost: data.Cost
            }
        });
        graphics.push(graphic);
    }
    return graphics;
}

async generateAIResultPoints(AIResultList: any[]): 
Promise<{ 
  id: number, 
  longitude?: number, 
  latitude?: number , 
  Location: string, 
}[]> {
  const points: { 
    id: number, 
    longitude?: number, 
    latitude?: number , 
    Location: string,  
  }[] = [];

  let idCounter: number = 0;
  for (let i = 0; i < AIResultList.length; i++) {

      
      if (AIResultList[i].Latitude == null){
        continue;
      }
      
      points.push({ 
        id: ++idCounter,
        longitude: Number(AIResultList[i].Latitude), 
        latitude: Number(AIResultList[i].Longitude), 
        Location: AIResultList[i].Location,
      });

  }
  return points;
}

createGraphicsFromPointsAIResult(AIResultPoints: { 
  id: number, 
  longitude?: number, 
  latitude?: number , 
  Location: string
}[]): Graphic[] {
  const graphics: Graphic[] = [];
  const mainMarker = new PictureMarkerSymbol({
    url: 'assets/map-page-component-images/mainPin.svg',
    width: '32px',
    height: '40px'
  });
  for (const data of AIResultPoints) {
      const point = new Point({
          longitude: data.longitude,
          latitude: data.latitude
      });

      const graphic = new Graphic({
          geometry: point,
          symbol: mainMarker,
          attributes: {
              Location: data.Location,
          }
      });
      graphics.push(graphic);
  }
  return graphics;
}


  createMainGraphicsFromPoints(pointsData: { id: number, longitude: number, latitude: number, Topic_OD: string, Detail_OD: string, Link_OD: string ,Picture_URL_OD: string, isMainNews: string}[]): Graphic[] {
    const graphics: Graphic[] = [];
    const mainMarker = new PictureMarkerSymbol({
      url: 'assets/map-page-component-images/mainPin.svg',
      width: '32px',
      height: '40px'
    });
    for (const data of pointsData) {
        const point = new Point({
            longitude: data.longitude,
            latitude: data.latitude
        });
        
        const graphic = new Graphic({
            geometry: point,
            symbol: mainMarker,
            attributes: {
                ObjectID: data.id,
                latitude: data.latitude,
                longitude: data.longitude,
                Topic_OD: data.Topic_OD,
                Detail_OD: data.Detail_OD,
                Link_OD: data.Link_OD,
                Picture_URL_OD: data.Picture_URL_OD,
                isMainNews: data.isMainNews
            }
        });
        graphics.push(graphic);
    }
    return graphics;
  }


  createGraphicsFromPoints(pointsData: { id: number, longitude: number, latitude: number, Topic_OD: string, Detail_OD: string, Link_OD: string ,Picture_URL_OD: string, isMainNews: string}[]): Graphic[] {
    const graphics: Graphic[] = [];
    for (const data of pointsData) {
        const point = new Point({
            longitude: data.longitude,
            latitude: data.latitude
        });
        
        const graphic = new Graphic({
            geometry: point,
            attributes: {
                ObjectID: data.id,
                latitude: data.latitude,
                longitude: data.longitude,
                Topic_OD: data.Topic_OD,
                Detail_OD: data.Detail_OD,
                Link_OD: data.Link_OD,
                Picture_URL_OD: data.Picture_URL_OD,
                isMainNews: data.isMainNews
            }
        });
        graphics.push(graphic);
    }
    return graphics;
  }

  createGraphicsFromPointsWithoutMainNews(pointsData: { id: number, longitude: number, latitude: number, Topic_OD: string, Detail_OD: string, Link_OD: string ,Picture_URL_OD: string}[]): Graphic[] {
    const subMarker = new PictureMarkerSymbol({
      url: 'assets/map-page-component-images/subPin.svg',
      width: '32px',
      height: '40px'
    });

    const graphics: Graphic[] = [];
    for (const data of pointsData) {
        const point = new Point({
            longitude: data.longitude,
            latitude: data.latitude
        });
        
        const graphic = new Graphic({
            symbol:subMarker,
            geometry: point,
            attributes: {
                ObjectID: data.id,
                latitude: data.latitude,
                longitude: data.longitude,
                Topic_OD: data.Topic_OD,
                Detail_OD: data.Detail_OD,
                Link_OD: data.Link_OD,
                Picture_URL_OD: data.Picture_URL_OD
            }
        });
        graphics.push(graphic);
    }
    return graphics;
  }

  /**
   * Generate cluster config
   */

  async generateClusterConfig(layer: FeatureLayer, view: MapView) {
    const scheme = await clusterLabelCreator
      .getLabelSchemes({ layer, view })
      .then(labelSchemes => labelSchemes?.primaryScheme);
  
    if (!scheme?.labelingInfo) {
      console.warn("No labelingInfo found");
      return {
        type: "cluster",
        labelingInfo: [],
        clusterMinSize: 30,
      };
    }
  
    scheme.labelingInfo.forEach((labelClass: __esri.LabelClass) => {
      labelClass.labelPlacement = "center-center";
  
      if (labelClass.symbol?.type === "text") {
        const textSymbol = labelClass.symbol as __esri.TextSymbol;
        textSymbol.yoffset = 4;
      }
    });
  
    return {
      type: "cluster",
      labelingInfo: scheme.labelingInfo,
      clusterMinSize: 30,
    };
  }

  /**
   * Create FeatureLayer by using Graphics[] and markers
   */

  async getFeatureLayer(source: Graphic[] , marker: PictureMarkerSymbol) {
    

    const featureLayer = new FeatureLayer({
        source: source,
        objectIdField: "ObjectID",
        fields: [
          {
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid"
          },
          {
            name: "Topic_OD",
            alias: "Topic",
            type: "string"
          },
          {
            name: "latitude",
            type: "string"
          },
          {
            name: "longitude",
            type: "string"
          },
          {
            name: "Detail_OD",
            alias: "Detail",
            type: "string"
          },
          {
            name: "Link_OD",
            alias: "Link",
            type: "string"
          },
          {
            name: "Picture_URL_OD",
            alias: "Picture",
            type: "string"
          },
          {
            name: "isMainNews",
            alias: "isMainNews",
            type: "string"
          }
        ],  
        renderer: new UniqueValueRenderer({
          field: "isMainNews",
          defaultSymbol: marker
        })
    })
    return featureLayer;
  }

  /**
   * Update MapView by remove all layers and graphics then adding subFeatureLayer to mapView and 
   * 
   * create polylineGraphics and mainGraphicsLayer as GraphicsLayer then draw them on mapViews
   */

  async updateMapView(mapView: MapView, subFeatureLayer: FeatureLayer , polylinePaths: any[], mainGraphics?: Graphic[]) {
    mapView.map.layers.removeAll();
    mapView.graphics.removeAll();
    
    if (subFeatureLayer.source) {
        mapView.map.layers.add(subFeatureLayer,1)
    }
    
    if (polylinePaths && mainGraphics) {
        const polyline = new Polyline({
            paths: polylinePaths
        });
        const polylineGraphic = new Graphic({
            geometry: polyline,
            symbol: new SimpleLineSymbol({ color: [219,112,147], width: 2 })
        }); 
        const polylineGraphics: Graphic[] = [];
        polylineGraphics.push(polylineGraphic)
        const polylineLayer = new GraphicsLayer({
          graphics: polylineGraphics
        })
        mapView.map.layers.add(polylineLayer);
        
        const mainGraphicsLayer = new GraphicsLayer({
          graphics: mainGraphics
        })
        mapView.map.layers.add(mainGraphicsLayer)
        
    }
  }

  /**
   * Navigate to the main news locations and calculate as Graphics[] or Graphic
   */

  async goToMainGraphic(mainGraphics:any[], mapView: MapView | null, mainLatitude: number | null , mainLongitude: number | null) {
    if (mainGraphics.length > 1) {
      mapView?.goTo({
        center: mainGraphics,
        time: 1000
      });
    } else {
      mapView?.goTo({
        center: [(mainLongitude?? 100.523186) , (mainLatitude?? 13.736717) ],
        zoom: 10,
        time: 1000
      });
    }
  }

  /**
   * Create connecting lines between main news
   *
   * using Graphics[]
   */

  async getPolylinePath(mainGraphics: Graphic[]) {
    const points = mainGraphics.map((graphic:any) => graphic.geometry);
    let polylinePaths = [];
    for (let i = 1; i < points.length; i++) {
      const startPoint = points[0];
      const endPoint = points[i];
      polylinePaths.push([startPoint.longitude, startPoint.latitude]);
      polylinePaths.push([endPoint.longitude, endPoint.latitude]);
    }
    return polylinePaths
  }
}

